// GTM Programmes, GTM Approval and GTM Tracker — the screen's strings in the portal's four languages (2026-10-21).
const en = {
  pdfFailed: "Could not make the PDF.",
  savedBefore: "{{error}} ({{n}} saved before this)",
  colFold: "Expand",
};
const ko = {
  pdfFailed: "PDF를 만들 수 없습니다.",
  savedBefore: "{{error}} (이전에 {{n}}건 저장됨)",
  colFold: "펼치기",
};
const vi = {
  pdfFailed: "Không tạo được tệp PDF.",
  savedBefore: "{{error}} (đã lưu {{n}} mục trước đó)",
  colFold: "Mở rộng",
};
const zh = {
  pdfFailed: "无法生成 PDF。",
  savedBefore: "{{error}}（此前已保存 {{n}} 项）",
  colFold: "展开",
};

const dictionary = { ns: 'xGtm', en, ko, vi, zh };

export default dictionary;
